export default function RisorseHero() {
  return (
    <section className="relative min-h-[60vh] sm:min-h-[70vh] lg:min-h-[80vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/1af8fa8e2dda20aa17e73d544da40e1c.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1F3B]/80 via-[#0B1F3B]/75 to-[#0B1F3B]/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-32 text-center">
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 sm:mb-8 leading-tight">
          Risorse
        </h1>
        <p className="text-lg sm:text-xl lg:text-2xl text-white/90 max-w-4xl mx-auto font-light leading-relaxed px-4">
          Guide, articoli e strumenti per comprendere il valore del patrimonio aziendale
        </p>
      </div>
    </section>
  );
}
